import axios from '@axios'

export default {
  listByEvento: eventoId => axios.get(`${process.env.VUE_APP_WCOND_API}/convidados/evento/${eventoId}`),
  create: (eventoId, convidado) => axios.post(`${process.env.VUE_APP_WCOND_API}/convidados/evento/${eventoId}`, convidado),
  togglePresenca: id => axios.put(`${process.env.VUE_APP_WCOND_API}/convidados/${id}/presenca`),
  remove: id => axios.delete(`${process.env.VUE_APP_WCOND_API}/convidados/${id}`),
}
